import React, { useEffect, useState }  from "react";
import {
  View,
} from "react-native";
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import "./assets/vendor/bootstrap/css/bootstrap-grid.min.css"
import "./assets/vendor/bootstrap-icons/bootstrap-icons.css"
import "./assets/vendor/aos/aos.css"
import "./assets/vendor/glightbox/css/glightbox.min.css"
import "./assets/vendor/swiper/swiper-bundle.min.css"
import "./assets/css/main.css"
  import "./assets/js/main.js"
  import 'bootstrap/dist/css/bootstrap.min.css';
import { ListarCategorias, ListarProductos } from "./app/utils/consultasAPI/Productos.js";

export default function App() {

  const [filter, setFilter] = useState('*'); // Estado inicial: Mostrar todos los elementos
const [Loading, setLoading]=useState(true);
const [Productos,setProductos]=useState([]);
const [Categorias,setCategorias]=useState([]);
const [Cambiando,setCambiando]=useState([]);

useEffect(()=>{
  setLoading(true);
  ListarCategorias(2013).then((pp)=>{
    setCategorias(pp);
    setFilter(pp[0].Nombre)
    console.log(pp);
    ListarProductos(11,1).then((ppp)=>{
      console.log(ppp)
      setProductos(ppp.Datos);
      setLoading(false);
    })
  })
  .catch((p) => {
    setProductos([]);
    setLoading(false);
  })
},[])

  return (
    <View style={{backgroundColor:"#fff",flex:1}}>
  <header id="header" className="header fixed-top d-flex align-items-center">
    <div className="container d-flex align-items-center justify-content-between">
      <a href="index.html" className="logo d-flex align-items-center me-auto me-lg-0">
        {false &&<img src={require("./assets/img/parrilla.jpg")} alt=""/>}
        <h1>Parrilladas<span> Papos</span></h1>
      </a>
    </div>
  </header>
<section id="hero" className="hero d-flex align-items-center section-bg">
    <div className="container">
      <div className="row justify-content-between gy-5">
        <div className="col-lg-5 order-2 order-lg-1 d-flex flex-column justify-content-center align-items-center align-items-lg-start text-center text-lg-start">
          <h2 data-aos="fade-up">Carta Virtual</h2>
          <p data-aos="fade-up" data-aos-delay="100">Un pequeño texto que invite a leer la carta</p>
        </div>
        <div className="col-lg-5 order-1 order-lg-2 text-center text-lg-start">
          <img src={require("./assets/img/parrilla.jpg")} className="img-fluid" alt="" data-aos="zoom-out" data-aos-delay="300"/>
        </div>
      </div>
    </div>
  </section>

  <main id="main">
  <section id="menu" className="menu">
      <div className="container">
        <div className="section-title" >
          <h2>Nuestra <span>Carta</span></h2>
        </div>
        <div className="row " data-aos={'fade-up'} data-aos-delay="300">
          <div className="col-lg-12 d-flex justify-content-center">
          <ul id="menu-flters">
            {Categorias.map((item,index)=>{
              return <li key={index} onClick={()=>{setCambiando(true); setFilter(item.Nombre);setCambiando(false);}} className={filter===item.Nombre?"filter-active":""}>{item.Nombre}</li>
            })}
            </ul>
          </div>
        </div>

        <div className="row menu-container" data-aos={'fade-up'} data-aos-delay="300">
          {/* Renderizar solo los elementos que coincidan con el filtro */}
          {Productos.filter(p=>p.Grupo.Nombre==filter).map((item, index) => {
              return (
                <div key={index} className={`col-lg-6 menu-item`} data-aos={'fade-right'} data-aos-once={false}>
                  <div className="menu-content">
                    <text>{item.Nombre}</text><span>{item.Precios[0].Precio.toFixed(2)}</span>
                  </div>
                  <div className="menu-ingredients">
                    {item.NombreCorto}
                  </div>
                </div>
              );
          })}
        </div>

      </div>
    </section>
    </main>
  <footer id="footer" className="footer">
    <div className="container">
      <div className="copyright">
        &copy; Copyright <strong><span>LudFact</span></strong>. All Rights Reserved
      </div>
    </div>
  </footer>
  <a href="#" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
  {Loading&&<div id="preloader" className="preloader"></div>}
      </View>
  );
}


